<footer class="footer">
  <div class="footer-container">
    <div class="footer-content">
      <!-- Company Info Section -->
      <div class="footer-section company-section">
        <div class="company-branding">
          <img src="assets/EZatwork.logo.1.2.png" alt="EZ@Work Logo" class="footer-logo" width="50" height="50">
        </div>
        <p class="footer-description">
          {{ 'footer.company.description' | translate }}
        </p>
        <div class="social-links" *ngIf="socialLinks.length > 0">
          <a *ngFor="let social of socialLinks"
             [href]="social.url"
             [attr.aria-label]="social.name"
             target="_blank"
             rel="noopener noreferrer"
             class="social-link">
            <span class="social-label">{{ social.icon }}</span>
          </a>
        </div>
      </div>

      <!-- Quick Links Section -->
      <div class="footer-section">
        <h3 class="footer-title">{{ 'footer.quickLinks.title' | translate }}</h3>
        <ul class="footer-links">
          <li><a routerLink="/dashboard">{{ 'footer.quickLinks.dashboard' | translate }}</a></li>
          <li><a routerLink="/projects">{{ 'footer.quickLinks.projects' | translate }}</a></li>
          <li><a routerLink="/clients">{{ 'footer.quickLinks.clients' | translate }}</a></li>
          <li><a routerLink="/finance/invoices">{{ 'footer.quickLinks.invoices' | translate }}</a></li>
          <li><a routerLink="/finance/reports">{{ 'footer.quickLinks.reports' | translate }}</a></li>
        </ul>
      </div>

      <!-- Resources Section -->
      <div class="footer-section">
        <h3 class="footer-title">{{ 'footer.resources.title' | translate }}</h3>
        <ul class="footer-links">
          <li><a routerLink="/about">{{ 'footer.resources.about' | translate }}</a></li>
          <li><a routerLink="/pricing">{{ 'footer.resources.pricing' | translate }}</a></li>
          <li><a routerLink="/help">{{ 'footer.resources.help' | translate }}</a></li>
          <li><a routerLink="/faq">{{ 'footer.resources.faq' | translate }}</a></li>
          <li><a routerLink="/documentation">{{ 'footer.resources.documentation' | translate }}</a></li>
          <li><a routerLink="/reviews/submit">{{ 'footer.resources.leaveReview' | translate }}</a></li>
        </ul>
      </div>

      <!-- Legal Section -->
      <div class="footer-section">
        <h3 class="footer-title">{{ 'footer.legal.title' | translate }}</h3>
        <ul class="footer-links">
          <li><a routerLink="/privacy">{{ 'footer.legal.privacy' | translate }}</a></li>
          <li><a routerLink="/terms">{{ 'footer.legal.terms' | translate }}</a></li>
          <li><a routerLink="/cookies">{{ 'footer.legal.cookies' | translate }}</a></li>
          <li><a routerLink="/security">{{ 'footer.legal.security' | translate }}</a></li>
          <li><a routerLink="/accessibility">{{ 'footer.legal.accessibility' | translate }}</a></li>
        </ul>
      </div>

      <!-- Contact Section -->
      <div class="footer-section">
        <h3 class="footer-title">{{ 'footer.contact.title' | translate }}</h3>
        <ul class="footer-links contact-info">
          <li>
            <mat-icon>language</mat-icon>
            <span>www.EZat.Work</span>
          </li>
          <li class="email-contact" (click)="openContactDialog()">
            <mat-icon>email</mat-icon>
            <a>{{ supportEmail }}</a>
          </li>
        </ul>
      </div>
    </div>

    <mat-divider class="footer-divider"></mat-divider>

    <!-- Bottom Bar -->
    <div class="footer-bottom">
      <p class="copyright">
        &copy; {{ currentYear }} {{ 'footer.copyright' | translate }}
      </p>
      <p class="made-with">
        {{ 'footer.madeWith' | translate }}
      </p>
    </div>
  </div>

  <!-- Back to Top Button -->
  <button
    *ngIf="showBackToTop"
    mat-fab
    class="back-to-top"
    (click)="scrollToTop()"
    [attr.aria-label]="'footer.backToTop' | translate">
    <mat-icon>keyboard_arrow_up</mat-icon>
  </button>
</footer>
